

export enum KalturaPlaylistType {
    dynamic=10,
	external=101,
	path=102,
	staticList=3
}